export const changeLocationHash = (hash: string): void => {
  if (history.pushState) {
    history.pushState(null, "", `#${hash}`);
  } else {
    location.hash = `#${hash}`;
  }
};
